import { PaletteMode } from '@mui/material';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ColorModeStore = {
    colorMode: PaletteMode;
    toggleColorMode: () => void;
};

export const useColorModeStore = create<ColorModeStore>()(
    persist(
        (set) => ({
            colorMode: 'light',
            toggleColorMode: () =>
                set((state) => ({
                    colorMode: state.colorMode === 'dark' ? 'light' : 'dark',
                })),
        }),
        { name: 'color-mode' },
    ),
);
